import styled from 'styled-components'

const StyledContainer = styled.div`
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px;
  flex-direction: column;
  &.red {
    background: var(--color-red-102);
    color: var(--color-red-107);
  }
  &.blue {
    background: var(--color-blue-101);
    color: var(--color-blue-108);
  }
  &.green {
    background: var(--color-primary-111);
    color: var(--color-primary-108);
  }
  .section-label {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 1.2rem;
  }
  .section-value {
    font-weight: 800;
    font-size: 2.8rem;
  }
`
interface IProps {
  label?: string
  value?: string
  color?: 'red' | 'green' | 'yellow' | 'blue'
  className?: string
}

const SectionColor = (props: IProps) => {
  const { label, value, color, className } = props

  return (
    <StyledContainer className={`${className} ${color}`}>
      <div className="section-label">{label}</div>
      <div className="section-value">{value}</div>
    </StyledContainer>
  )
}

export default SectionColor
